import { HttpAxiosRequest } from '../httpAxiosBase'
import { SistemaTipo } from 'src/types/enum/enum'
import { Sistema } from 'src/pages/messages/types'
import { EntityListWithPagination, PaginacionRequest } from 'src/types'

export type AprobacionArchivo = {
    id: number
    codArchivoTipo: number
    nombreArchivo: string
    descArchivoTipo: string
}

export type AprobacionMensaje = {
    id: number
    codSistema: number
    codSistemaPrincipal: number
    codSistemaTipo: SistemaTipo
    idOperacion: number
    referencia: string
    fechaAprobacion: string | null
    archivos: AprobacionArchivo[]
}

export const HttpAprobaciones = {
    getEndpoint: (url = ''): string => `workflow/aprobaciones${url}`,

    getSistemasByPrincipal: (codSistemaPrincipal: number): Promise<Sistema[]> =>
        HttpAxiosRequest.get(HttpAprobaciones.getEndpoint(`/sistemas?codSistemaPrincipal=${codSistemaPrincipal}`)),

    getMensajesAprobadosPorSistema: (
        codSistema: number,
        paginacion: PaginacionRequest
    ): Promise<EntityListWithPagination<AprobacionMensaje>> =>
        HttpAxiosRequest.getWithQueryParamsSerializer(HttpAprobaciones.getEndpoint('/mensajes'), {
            codSistema,
            ...paginacion
        })
} as const
